// extracted by mini-css-extract-plugin
export default {"dropup_container":"DropUpMenu_dropup_container__nkrDm","dropdown":"DropUpMenu_dropdown__iA7Vl"};